{
    "SSO_Login_Title": "Single Sign-On (SSO)",
    "SSO_Login_Description": "Please wait, validating user details. This shouldn't take long.",
    "SSO_Login_Error": "Sorry, we are unable to locate you. Please try again. If this problem persists, please contact your application administrator.",
    "SSO_MissingCode_Error": "Sorry, something went wrong. Please try again. If this problem persists, please contact your application administrator.",
    "NAME": "SSOLanguage"
}
